module.exports = __webpack_public_path__ + "static/media/banner-planos.51efc485.png";